// 首页进来---林权/农村详情
<template>
  <div v-loading='Loading'>
    <header-img :list="headerList"></header-img>
    <div class="container-main">
<!--      <div class="top-title">项目详情 </div>-->
      <div class="flex-around delete-around">
         <!-- style=" width: 408px;" -->
        <div class="el-carousel-wrap">
           <!-- height="308px" -->
          <el-carousel @change="carouselChange" ref="villageCarousel" height="372px" class="banner" indicator-position="none" arrow="always" :autoplay="false">
            <div v-if="data.imgList && data.imgList.length">
              <el-carousel-item v-for="(item, index) in data.imgList" :key="index">
                <img :src="item.imgUrl" />
              </el-carousel-item>
            </div>
            <div v-else>
              <el-carousel-item v-for="(item, index) in imgList" :key="index">
                <img src="@/assets/area/baise.png" />
              </el-carousel-item>
            </div>
            <div class="flag">
<!--              <img v-if="routerStatus" :src="require(`@/assets/icon/stauts_icon/${routerStatus}.png`)" alt="">-->
                <span v-if="data.tranferType != 1">{{routerStatus == 3 ? '挂牌中':routerStatus == 4 ? '已摘牌':routerStatus == 5 ? '未成交':routerStatus == 6 ? '已成交':routerStatus == 10 ? '竞价结束':routerStatus == 15 ? '摘牌审批中':''}}</span>
                <span v-else>{{newStatus == 0 ?'未开始':newStatus == 1 ? '报名中':newStatus == 2 ? '即将竞价':newStatus == 3 ? '竞价中':newStatus == 4 ? '已成交':newStatus == 5 ? '未成交':''}}</span>
            </div>
          </el-carousel>
          <div class="mini-carousel-list">
            <div class="arrow-btn" @click="changeCarousel('prev')">&lt;</div>
            <div class="mini-carousel-box">
              <div ref='miniCarouselContent' style="margin-left: 0;" class="mini-carousel-content" v-if="data.imgList && data.imgList.length">
                <img @click="activeMiniFn(index)" v-for="(item, index) in data.imgList" :key="index" :src="item.imgUrl" :class="{'mini-active': miniActive === index}" :id="'miniImg'+index" />
              </div>
              <div class="mini-carousel-content" v-else>
                <img src="@/assets/area/baise.png" />
              </div>
            </div>
            <div class="arrow-btn" @click="changeCarousel('next')">&gt;</div>
          </div>
        </div>
        <div class="content-text">
          <div>
            <h2 style="text-align: left;">{{data.name}}</h2>
          </div>
<!--          <div class="business-type">-->
<!--            <div class="title">业务类型</div>-->
<!--            <div class="type">{{data.businessTypeDesc}}</div>-->
<!--          </div>-->
          <div class="flex-between">
            <div>项目编号： {{data.projectNum ? data.projectNum : '无'}}</div>
            <div style="font-size: 12px;color: #A8AAAE;line-height: 30px;">{{data.viewNum}}次浏览</div>
          </div>
          <div class="price-box-wrap">
            <div v-if="data.tranferType != 1" class="state-box" :class="{'red':routerStatus == 3||routerStatus == 6||routerStatus == 12}">
              <div v-show="routerStatus == 3">
                <!--                <img src="@/assets/icon/statuts/status02.png" alt="">-->
                <p>挂牌中</p>
              </div>
              <div v-show="routerStatus == 4">
                <!--                <img src="@/assets/icon/statuts/status02.png" alt="">-->
                <p>已摘牌</p>
              </div>
              <div v-show="routerStatus == 5">
                <!--                <img src="@/assets/icon/statuts/status01.png" alt="">-->
                <p>未成交</p>
              </div>
              <div v-show="routerStatus == 6">
                <!--                <img src="@/assets/icon/statuts/status01.png" alt="">-->
                <p>已成交</p>
              </div>
              <div v-show="routerStatus == 11">
                <!--                <img src="@/assets/icon/statuts/status01.png" alt="">-->
                <p>已交易</p>
              </div>
              <div v-show="routerStatus == 12">
                <!--                <img src="@/assets/icon/statuts/status03.png" alt="">-->
                <p>交易完成</p>
              </div>
              <div v-show="routerStatus == 10">
                <!--                <img src="@/assets/icon/statuts/status03.png" alt="">-->
                <p>竞价结束</p>
              </div>
              <div v-show="routerStatus == 15">
                <!--                <img src="@/assets/icon/statuts/status02.png" alt="">-->
                <p>摘牌审批中</p>
              </div>
            </div>
            <div v-else class="state-box" :class="{'red':newStatus == 3||newStatus == 4}">
              <div v-show="newStatus == 0">
                <p>未开始</p>
              </div>
              <div v-show="newStatus == 1">
                <p>报名中</p>
              </div>
              <div v-show="newStatus == 2">
                <p>即将竞价</p>
              </div>
              <div v-show="newStatus == 3">
                <p>竞价中</p>
              </div>
              <div v-show="newStatus == 4">
                <p>已成交</p>
              </div>
              <div v-show="newStatus == 5">
                <p>未成交</p>
              </div>
            </div>
            <div  v-if="data.tranferType == 1" :class="{'flex-between':true, 'price-box': true}" :style="{color:'#60697E', 'background-image': 'url('+priceLangUrl+')'}">
              <div>
                <div class="must price-text"> {{`${data.listingPrice}元${unitAppend}`}}</div>
                <div>起拍价格</div>
              </div>
              <div>
                <div class="must price-text">{{data.maxReportAmount?data.maxReportAmount.toString()+'元'+unitAppend:'无'}}</div>
                <div>当前最高报价</div>
              </div>
            </div>
            <div class="price-box02" v-if="data.tranferType != 1 && data.tranferType != 4">
              <p class="title">挂牌价格</p>
              <p class="price">￥<span>{{data.listingPrice}}元{{unitAppend}}</span></p>
            </div>
            <div class="price-box02" v-if="data.tranferType == 4">
              <p class="title">价格面议</p>
            </div>
          </div>
          <el-divider />
          <div>
            <div class="flex-start">
              <div>
                <span>产权类型</span>
                <div>{{data.businessTypeDesc}}</div>
              </div>
              <div>
                <span>流转方式</span>
                <div v-if="data.businessType == 7">{{data.transferMethod}}</div>
                <div v-else>{{data.circulWay==='ZR'?'转让':data.circulWay==='CZ'?'出租':''}}</div>
              </div>
            </div>
            <div class="flex-start">
              <div>
                <span>流转数量</span>
                <div v-if="data.businessType == 1 || data.businessType == 2">{{data.holdArea}}{{holdAreaList[data.holdAreaUnit]}}</div>
                <div v-else>{{data.number}}{{data.businessType == 7?data.unit:customUnitOption[data.unit]}}</div>
              </div>
              <div v-if="(data.circulWay==='CZ'&&data.businessType != 7)||data.businessType == 7">
                <span >流转期限</span>
                <div>{{data.transferPeriod}}</div>
              </div>
            </div>
            <div class="flex-start">
              <div style="width: 100%">
                <span>付款方式</span>
                <div>{{data.paymentMethod}}</div>
              </div>
            </div>
            <div class="flex-start">
              <div><span>交易方式</span> <div>{{data.tranferType == 1 ? '网络竞价': data.tranferType == 2 ? '协议转让': data.tranferType == 3 ? '预售': data.tranferType == 4 ? '线下交易': ''}}</div></div>
            </div>
            <div class="border-box box2" v-if="data.tranferType == 1">
              <div class="flex-row">
                <div style="width: 50%">
                  <div><span class="mw">竞标保证金</span> <span class="must_small">{{data.tranferEnsureAmount+'元' || '无'}}</span></div>
                </div>
                <div style="width: 50%">
                  <div><span class="mw">竞价阶梯</span> <span class="must_small">{{data.auctionInterval+'元/次' || '无'}}</span></div>
                </div>
              </div>
              <div class="flex-row">
                <div style="width: 50%">
                  <div><span class="mw">起拍价格</span>
                    <span class="must_small">
                  {{`${data.listingPrice}元${unitAppend}`}}
                </span>
                  </div>
                </div>
                <div style="width: 50%">
                  <div><span class="mw">延时周期</span> <span class="must_small">{{data.auctionDelayTime || '--'}}分钟</span></div>
                </div>
              </div>
            </div>
<!--            <div class="flex-start">-->
<!--              <div v-if="data.tranferType != 4">-->
<!--                <span>挂牌价格</span>-->
<!--                <span class="must_small" v-if="data.businessType == 1 || data.businessType == 2">-->
<!--                  {{data.bidType==1 ? `${data.listingPrice}元/${data.holdAreaUnit || '亩'}` : `${data.listingPrice}元/${data.holdArea}${data.holdAreaUnit || '亩'}`}}-->
<!--                </span>-->
<!--                <span class="must_small" v-else>-->
<!--                  {{data.bidType==1 ? `${data.listingPrice}元/${data.unit}` : `${data.listingPrice}元/${data.number}${data.unit}`}}-->
<!--                </span>-->
<!--              </div>-->
<!--              <div><span>项目编号</span> <span>{{data.projectNum ? data.projectNum : '无'}}</span></div>-->
<!--            </div>-->
<!--            <div class="flex-start">-->
<!--              <div v-if="data.tranferType != 4"><span>交易保证金（元）</span> <span class="must_small">{{data.tranferEnsureAmount || '无'}}</span></div>-->
<!--              <div><span>交易方式</span> <span>{{data.tranferType == 1 ? '网络竞价': data.tranferType == 2 ? '协议转让': data.tranferType == 3 ? '预售': data.tranferType == 4 ? '线下交易': ''}}</span></div>-->
<!--            </div>-->

<!--            <div class="flex-start">-->
<!--              <div v-if="data.tranferType != 4"><span>预付款（元）</span> <span class="must_small">{{data.advancePaymentAmount || '无'}}</span></div>-->
<!--              <div v-if="data.tranferType == 1"><span>竞价阶梯（元/次）</span> <span class="must_small">{{data.auctionInterval || '无'}}</span></div>-->
<!--              <div v-else-if="data.tranferType == 4"></div>-->
<!--              <div v-else><span>交易付款方式</span><span>一次性支付</span></div>-->
<!--            </div>-->
<!--            <div class="flex-start" v-if="data.tranferType == 1">-->
<!--              <div><span>交易付款方式</span><span>一次性支付</span></div>-->
<!--            </div>-->
<!--            <div class="flex-start" v-if="data.tranferType == 1">-->
<!--              <div ><span>当前最高报价（元）</span> <span class="must_small">{{data.maxReportAmount || '无'}}</span></div>-->
<!--              <div><span>延时周期</span> <span>{{data.auctionDelayTime || '&#45;&#45;'}}分钟</span></div>-->
<!--            </div>-->
            <el-divider />
            <div class="process-list process-show" v-if="data.tranferType == 1">
              <div :class="{'not-start-process': !isApplyStart}">开始报名</div>
              <div :class="{'not-start-process': !isApplyEnd}">截止报名</div>
              <div :class="{'not-start-process': !isStart}">开始竞价</div>
              <div :class="{'not-start-process': !finish}">竞价结束</div>
            </div>
            <div v-else class="process-list process-show" >
              <div>开始挂牌</div>
              <div :class="{'not-start-process': !finish}">截止挂牌</div>
            </div>
            <!-- <el-steps v-if="data.tranferType == 1" :active="finish ? 4 : isStart? 3:isApplyStart?2:isApplyEnd?1: null" :class="{'finish':finish}"> -->
            <el-steps v-if="data.tranferType == 1" :active="finish ? 4 : isStart? 4:isApplyEnd?3:isApplyStart?2: null" :class="{'finish':finish}">
              <el-step v-if="isApplyStart" icon="el-icon-success"/>
              <el-step v-else icon="fa fa-circle"> </el-step>
              <el-step v-if="isApplyEnd" icon="el-icon-success"/>
              <el-step v-else icon="fa fa-circle"> </el-step>
              <el-step v-if="isStart"  icon="el-step__icona"> </el-step>
              <el-step v-else icon="fa fa-circle"> </el-step>
              <el-step v-if="finish" icon="el-icon-remove"/>
              <el-step v-else icon="fa fa-circle"/>
            </el-steps>
            <el-steps class="step02-box" v-else :active="finish ? 3 : 2" :class="{'finish':finish}">
              <el-step icon="el-icon-success"/>
              <el-step icon="el-step__icona"> </el-step>
              <el-step v-if="finish" icon="el-icon-remove"/>
              <el-step v-else icon="fa fa-circle"/>
            </el-steps>
            <div class="process-list">
              <div v-if="data.tranferType == 1">{{data.applyStartTime }}</div>
              <div v-if="data.tranferType == 1">{{data.applyEndTime }}</div>
              <div>{{data.tranferType == 1 ? data.auctionStartTime: data.applyTime}}</div>
              <div>{{data.tranferType == 1 ? data.auctionEndTime: data.endTime}}</div>
            </div>
          </div>
          <div style="text-align:center;" v-if="!bidding">
            <el-button class="ApplyInvestment" :class='{disabledBtn: routerStatus != 3,"is-hanger":isHanger }' type="primary" @click="newDiaShowEvt" v-if="(data.tranferType == 1 || data.tranferType == 4) && !finish && isApplyStart">{{btnText2}}</el-button>
            <!--竞拍-->
            <el-button class="ApplyInvestment" :class='{disabledBtn: routerStatus != 3}' type="primary"  v-else-if="routerStatus == 6">已成交</el-button>
            <el-button class="ApplyInvestment" :class='{disabledBtn: routerStatus != 3}' type="primary"  v-else-if="routerStatus == 4">已摘牌</el-button>
            <el-button class="ApplyInvestment disabledBtn" type="primary"  v-else-if="!isApplyStart">未开始</el-button>
            <el-button class="ApplyInvestment" :class='{disabledBtn: routerStatus != 3}' type="primary"  v-else-if="finish">已结束</el-button>
            <el-button class="ApplyInvestment" :class='{disabledBtn: routerStatus != 3}' type="primary"  @click="applicationDelisting" v-else>{{btnText}}</el-button>
            <!--协议转让-->
            <div style="margin-bottom: 50px;margin-top: 10px;" v-if="!isSubmitMaterial">
              <el-checkbox v-model="checked"></el-checkbox>
<!--              我已阅读并同意<el-link type="danger" :underline="false" @click="ruleDiaShow = true">《{{transactionName}}》</el-link>-->
              <span style="color: #f35c4c;margin-left: 5px;">我已了解交易相关信息与要求，愿承担由此产生的一切责任</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-main village-tabs" v-if="bidding">
      <div class="container-con">
        <div class="box">
          <div class="box-l">距结束</div>
          <div class="box-r red">
            {{ deadline.td }} <span>天</span> {{ deadline.th }} <span>时</span>
            {{ deadline.tm }} <span>分</span> {{ deadline.ts }}
            <span>秒</span>
          </div>
        </div>
        <div class="box">
          <div class="box-l">当前价</div>
          <div class="box-r red box-flex">
            {{ maxReportAmount ? maxReportAmount : "--" }}元{{unitAppend}}
            <span>出价人：{{ userName ? userName : "--" }}</span>
          </div>
        </div>
        <div class="box">
          <div class="box-l">出价</div>
          <div class="box-r">
            <el-input
              placeholder="请输入"
              v-model="quotedAmount"
              @keyup.native="changeCode('quotedAmount')"
              class="inp"
            ></el-input>
            <!-- <el-button
              type="danger"
              style="margin-left: 60px; font-size: 18px"
              @click="getMaxAmount"
              >总价</el-button
            > -->
          </div>
        </div>
      </div>
      <div style="text-align: center">
        <el-button
          class="ApplyInvestment"
          :class="{ disabledBtn: routerStatus != 3 }"
          type="primary"
          @click="offerPrice"
          >{{'出价'}}</el-button
        >
        <div style="margin-top: 20px; font-size: 12px; color: #f45b51">
          温馨提示：若中标方未按规定时间签订合同和付清相关款项，则视为违约，没收全部项目保证金
        </div>
      </div>
    </div>
    <div class="container-main mt20 village-tabs">
      <el-tabs v-model="activeName">
        <el-tab-pane name="1">
          <span slot="label">
            <i class="el-icon-my el-icon-my-about"></i>
            标的相关
            <i class="triangle-img" v-if="activeName==1"></i>
          </span>
          <el-table :data="data.businessType == 1 ?tableDataNc: data.businessType == 2 ? tableDataLq : data.businessType == 7 ?tableDataHanger:tableDataCustom" :span-method="!listingMainPartList.length ? beforeArrayMethod:arrayMethod" fixed="left" :show-header="false" border style="width:90%;margin: 20px auto;" :cell-class-name="tableCellClassName" size="mini">
            <el-table-column width="80px" prop="title" align="center"></el-table-column>
            <el-table-column width="80px" prop="name" align="center"></el-table-column>
            <el-table-column prop="mark" align="left">
              <template slot-scope="scope">
                <div v-if="scope.row.name =='相关资料' " style="text-align:left;">
                  <el-form class="form formRelative" label-position="left">
                    <el-row class="mt20">
                      <el-col v-for="(item) of roleFileList" :key="item.fileNameKey">
                        <div v-if="item.maxNumber == 1 && item.isShow">
                          <el-form-item :label="item.fileName" label-width="350px" style="margin-bottom: 0;" v-if="item.fileList && item.fileList.length">
                            <OneUpload style="display: inline-block; margin-left:30px;" :fileFuther="item" :showBtnFlag="'2'" />
                          </el-form-item>
                        </div>
                        <div v-if="item.maxNumber != 1 && item.isShow">
                          <el-form-item :label="`${item.fileName}`" label-width="350px" style="margin-bottom: 0;" v-if="item.fileList && item.fileList.length">
                            <ListUpload style="display: inline-block; margin-left:30px;" :fileFuther="item" />
                          </el-form-item>
                        </div>
                      </el-col>
                      <div v-for="(item,ind) of data.otherFileList" :key="ind">
                        <div v-if="item.isShow && item.fileUrl">
                          <el-form-item :label="item.fileName" label-width="350px" style="margin-bottom: 0;">
                            <OtherOneUpload style="display: inline-block; margin-left:30px;" :fileFuther="item" :showBtnFlag="'2'" :delBtn="false" />
                          </el-form-item>
                        </div>
                      </div>
                    </el-row>
                  </el-form>
                </div>
                <div v-else>{{scope.row.mark}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="value" align="left"></el-table-column>
            <el-table-column prop="marks" align="left"></el-table-column>
            <el-table-column prop="values" align="left"></el-table-column>
          </el-table>
        </el-tab-pane>
        <!-- 协议转让的叫交易公告，网络竞价的叫竞买公告。 -->
        <el-tab-pane name="2">
          <span slot="label">
            <i class="el-icon-my el-icon-my-notice"></i>
            {{data.tranferType == 1 ? '竞买公告': '交易公告'}}
            <i class="triangle-img" v-if="activeName==2"></i>
          </span>
          <el-table v-if="data.isShowProject==1" :data="data.bidNotice.bidNoticDetail" :span-method="arrayMethods" :show-header="false" border style="width:90%;margin: 20px auto;" :cell-class-name="tableCellClassNames" size="mini">
            <el-table-column prop="name" align="center" width="80px"></el-table-column>
            <el-table-column prop="labelName" align="center" width="150px"></el-table-column>
            <el-table-column align="center">
              <template slot-scope="scope">
                <div v-html="scope.row.value" class="html-table-wrap" style="text-align:left;width:100%;"></div>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="data.isShowProject==2">
            <div v-html="data.projectResult"></div>
          </div>
        </el-tab-pane>
        <!-- 协议转让的就是交易记录，网络竞价的就是竞买记录。 -->
        <el-tab-pane name="3" v-if="data.isShowBidInfo == 1">
          <span slot="label">
            <i class="el-icon-my el-icon-my-record"></i>
            {{data.tranferType == 1 ? '竞买记录': '交易记录'}}
            <i class="triangle-img" v-if="activeName==3"></i>
          </span>
          <el-table :data="data.transRecords" style="width:90%;margin: 20px auto;" size="mini" :header-row-class-name="'warning-header'" height="350">
            <el-table-column width="50px" label="序号" type="index" :index="index=>index+1" align="center"></el-table-column>
            <el-table-column label="竞买人" prop="name" align="center">
              <template slot-scope="scope">
<!--                <div v-if="data.isShowBidder == 1">-->
<!--                  {{scope.row.name}}-->
<!--                </div>-->
<!--                <div v-else>-->
<!--                   {{scope.row.name.substr(0,1) + '*'}}-->
<!--                </div>-->
                <div>{{scope.row.name}}</div>
              </template>
            </el-table-column>
            <el-table-column label="价格(元)" prop="amount" align="center"></el-table-column>
            <el-table-column label="时间" prop="createdTime" align="center"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane name="4">
          <span slot="label">
            <i class="el-icon-my el-icon-my-result"></i>
            交易结果公示
            <i class="triangle-img" v-if="activeName==4"></i>
          </span>
          <div v-html="data.tradeResult" class="html-table-wrap"></div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <delisting-start :business-type="businessType" :delistingShow.sync='delistingStartShow' :data.sync='data' @dialogCloses="delistingStartShow = false" @diaSccessEvt="diaSccessEvt"></delisting-start>
    <delisting-end :delistingShow.sync='delistingShow' :data.sync='data' :delistingData.sync='delistingData' @dialogCloses="delistingShow = false" @diaSccessEvt="diaSccessEvt"></delisting-end>
    <dia :show.sync='dialogVisible' :data.sync='data' @dialogCloses="dialogVisible = false" @diaSccessEvt="diaSccessEvt"></dia>
    <dia-offer :unitAppend="unitAppend" :show.sync='dialogOfferVisible' :data.sync='data' :delistingData.sync='delistingData' @dialogCloses="dialogOfferVisible = false" @diaSuccessEvt="diaSuccessEvt" />
    <Dialog :show="diaShow" @dialogClose="diaShow=false" :img="'success.png'" :title="'温馨提示'" :content="'已提交'" :btn="'返回'" :btn2="data.tranferType == 1 ? '查看我的竞价':'查看我的投资'" />
    <Dialog :show="applayShow" @dialogClose="applayShow=false" :img="'success.png'" :title="'温馨提示'" :content="delistingStatus" :btn="'返回'" btn3="查看我的申请" />
    <!-- 交易规则弹框 -->
    <Dialog :show.sync="ruleDiaShow" @dialogClose="ruleDiaShow=false" :width="ruleContent.length > 1000 ? '800px': ''" :top="ruleContent.length > 1000 ? '15vh': '30vh'" :title="transactionName" :content="ruleContent" :btn="'关闭'" />
    <!-- 交易扣款温馨提示 -->
    <ruleTip :show.sync="ruleTipDiaShow" @ruleTipClose='ruleTipDiaShow= false' :transactionViolate='transactionViolate'></ruleTip>
    <Dialog
      :show="diaJjShow"
      @dialogClose="diaJjShow = false"
      :img="'success.png'"
      :title="'温馨提示'"
      :content="contentMsg"
    />

  </div>
</template>

<script>
import Navbar from '@/components/Navbar';
import HeaderImg from '@/components/HeaderImg';
import OneUpload from '@/components/DataUpload/OneUpload.vue';
import ListUpload from '@/components/DataUpload/ListUpload.vue';
import dia from './components/dia.vue'
import diaOffer from './components/dia-offer.vue'
import delistingStart from './components/delisting-start.vue'
import delistingEnd from './components/delisting-end.vue'
import Dialog from '@/components/Dialog';
import ruleTip from './components/ruleTip.vue';
import { sessionStore } from '@/utils/data-management';
import OtherOneUpload from '@/components/DataUpload/OtherOneUpload.vue';
import priceLang from '@/assets/price-lang.png'
// import { dateFtt } from "@/utils/timeFormat";
export default {
  components: {
    HeaderImg,
    OneUpload,
    ListUpload,
    delistingStart,
    delistingEnd,
    dia,
    diaOffer,
    Dialog,
    ruleTip,
    Navbar,
    OtherOneUpload,
  },
  data() {
    return {
      //设备类型
      deviceTypeList: {
        '0201': '小型水利',
        '0202': '农业生产',
        '0203': '机电设备',
        '0204': '工程机械',
        '0205': '其他'
      },
      propertyTypeList: {
        '01': '商铺',
        '02': '厂房',
        '03': '办公用房',
        '04': '商业用房',
        '05': '住宅',
        '06': '综合用房',
        '07': '其他'
      },
      whetherList: {
        '1': '是',
        '0': '否'
      },
      areaStatus: [], //自定义类型
      //自定义类型标的单位
      customUnitOption: {
        '01': '元',
        '02': '万元',
        '03': '股',
        '04': '万股',
        '05': '元每资本金',
        '06': '元每股',
        '07': '台',
        '09': '亩',
        '10': '月',
        '11': '期',
        '12': '套',
        '13': '吨',
        '14': '公斤',
        '15': '克',
        '16': '个',
        '17': '箱',
        '18': '平方米',
        '19': '%'
      },
      //林木标的类别
      forestRightCategory: {
        '0501': '林木',
        '0502': '活立木',
        '0503': '原木',
        '0504': '地上林产品',
        '0505': '林地承包经营权',
        '0506': '其他林产品'
      },
      holdAreaList: {
        '09': '亩',
        '18': '平方米',
        '13': '吨',
        '14': '公斤',
        '16': '个'
      },
      industryCodelist: [], //行业分类
      //企业性质
      companyPropertiesList:{
        'A05001': '国资监管机构/政府部门',
        'A05002': '国有独资公司（企业）/国有全资企业',
        'A05003': '国有控股企业',
        'A05004': '国有事业单位，国有社团等',
        'A05005': '国有及国有控股企业',
        'A05006': '国有参股企业',
        'A05007': '非国有企业',
        'A05008': '外资企业',
        'A05009': '其他'
      },
      //企业类型
      companyTypeList: {
        'A19001': '全民所有制企业',
        'A19002': '有限责任公司',
        'A19003': '股份有限公司',
        'A19004': '集体所有制企业',
        'A19005': '合伙企业',
        'A19006': '其他',
      },
      //经济规模
      economicScaleList: {
        'A04001': '大型',
        'A04002': '中型',
        'A04003': '小型',
        'A04004': '微型'
      },
      //资金来源
      sourceFundList: {
        '01': '自有',
        '02': '融资',
        '03': '其他'
      },
      //权属类型
      ownershipTypeOption: {
        '01': '国有',
        '02': '集体',
        '03': '企业',
        '04': '个人',
      },
      //土地标的类别
      propertychildtypeOption: {
        '0401': '水域',
        '0402': '园地',
        '0403': '草地',
        '0404': '耕地',
        '0405': '林地',
      },
      businessType: '',
      timer: null,
      unitTimeOption: {
        '0': '无',
        '1': '年 ',
        '2': '季度 ',
        '3': '月 '
      },
      isHanger: false,
      isSubmitMaterial:false,
      btnText: '意向报名',
      btnText2: '意向报名',
      routerStatus: '',
      newStatus: '',
      priceLangUrl: priceLang,
      delistingShow: false,
      diaJjShow: false,
      dialogOfferVisible: false,
      offerPriceTime: true,
      delistingStartShow: false,
      diaShow: false,
      isStart: false,
      isApplyStart: false,//报名是否开始
      isApplyEnd: false,//报名是否结束
      applayShow: false,
      dialogVisible: false,
      Loading: false,
      data: {
        bidNotice: {
          bidNoticDetail: [],
        },
        customFields:[]
      },
      headerList: [
        { name: '首页', path: '/Home' },
        { name: '产权交易', path: '' },
        { name: '项目详情' },
      ],
      roleFileList: [],
      delistingData:{},
      ruleDiaShow: false,
      ruleTipDiaShow: false,
      checked: false,
      ruleContent: '',
      userName: '',
      transactionName: '',
      transactionViolate: '',
      // imgList: [1, 2, 3], //标的图
      imgList: [1], //标的图
      miniActive: 0,
      miniCarouselBox: 460, // 轮播页宽
      miniPicture: 86, // 轮播单位页
      index: '',
      activeName: '1',
      tableDataLq: [
        {
          title: '标的相关',
          name: '标的信息',
          mark: '项目名称',
          value: '',
          marks: '流转方式',
          values: '',
        },
        {
          mark: '标的名称',
          value: '',
          marks: '标的坐落所在地区',
          values: '',
        },
        {
          mark: '权属类型',
          value: '',
          marks: '标的类别',
          values: '',
        },
        {
          name: '相关资料',
          mark: '',
        },
      ],
      tableDataNc: [
        {
          title: '标的相关',
          name: '标的信息',
          mark: '项目名称',
          value: '',
          marks: '流转方式',
          values: '',
        },
        {
          mark: '标的名称',
          value: '',
          marks: '标的坐落所在地区',
          values: '',
        },
        {
          mark: '权属类型',
          value: '',
          marks: '标的类别',
          values: '',
        },
        {
          mark: '持有面积',
          value: '',
          marks: '土地四至',
          values: '',
        },
        {
          mark: '土地类型',
          value: '',
          marks: '土地用途',
          values: '',
        },
        {
          mark: '使用期限',
          value: '',
          marks: '承包权人',
          values: '',
        },
        {
          mark: '经营权人',
          value: '',
          marks: '权证名称',
          values: '',
        },
        {
          mark: '权证编号',
          value: '',
          marks: '权证年限(年)',
          values: '',
        },
        // {
        //   mark: '承包方式',
        //   value: '',
        //   marks: '持有面积',
        //   values: '',
        // },
        {
          mark: '转出方式',
          value: '',
          marks: '是否属于再次转出',
          values: '',
        },
        {
          mark: '是否存在他项权利人',
          value: '',
        },
        {
          name: '相关资料',
          mark: '',
        },
      ],
      tableDataCustom:[
        {
          title: '标的相关',
          name: '标的信息',
          mark: '自定义类型',
          value: '',
          marks: '项目名称',
          values: '',
        },
        {
          mark: '标的名称',
          value: '',
          marks: '流转方式',
          values: '',
        },
        {
          mark: '标的坐落所在地区',
          value: '',
          marks: '权属类型',
          values: '',
        },
        {
          mark: '标的数量',
          value: '',
          marks: '标的单位',
          values: '',
        },
        {
          mark: '是否存在他项权利人',
          value: '',
          marks: '',
          values: '',
        },
        {
          name: '相关资料',
          mark: '',
        },
      ],
      tableDataHanger: [
        {
          title: '标的相关',
          name: '标的信息',
          mark: '标的名称',
          value: '',
          marks: '标的使用范围',
          values: '',
        },
        {
          mark: '标的数量',
          value: '',
          marks: '标的单位',
          values: '',
        },
        {
          mark: '流转期限',
          value: '',
          marks: '流转方式',
          values: '',
        },
        {
          mark: '是否存在他项权利人',
          value: '',
          marks: '',
          values: '',
        },
        {
          name: '相关资料',
          mark: '',
        }
      ],
      listingMainPartList:[],
      quotedAmount: "",
      maxReportAmount: "",
      plateCode: "",
      delistingStatus: "",
      contentMsg: "",
      bidding: false, //开始出价
      isEndTime: 10000,
      deadline: { td: "00", th: "00", tm: "00", ts: "00", timeStatus: false },
      finish: false
      // beforeList:[]
    };
  },
  computed: {
    unitAppend(){
      if(this.data.bidType==1){
        return  `${((this.data.unitNum=='无'||!this.data.unitNum)?'':'/'+this.data.unitNum)+
        ((this.data.unitTime=='0'||!this.data.unitTime)?'':'/'+this.unitTimeOption[this.data.unitTime])}`
      }else {
        return ''
      }
    }
  },
  watch: {
    ruleTipDiaShow(newVal, oldVal) {
      if (newVal == false && oldVal == true) {
        this.dialogVisible = true;
      }
    },
  },
  methods: {
    //数据字典 获取承包方式/自定义类型
    getAreaStatus() {
      return this.$api.user.getListByProperties({ properties: 1 }).then((res) => {
        this.areaStatus = res.data
      })
    },
    //行业分类
      getIndustryCodeList(){
        return this.$api.user.getSelectIndustryList().then(res=>{
          if(res.code===1000){
            this.industryCodelist = res.data
          }
        })
      },
      //匹配行业分类名字
      getCodeLabel(code){
        for (let i=0; i<this.industryCodelist.length;i++){
          for (let j=0; j<this.industryCodelist[i].subsetList.length;j++){
            if(this.industryCodelist[i].subsetList[j].industryCode===code){
              return  this.industryCodelist[i].industryName + '/' + this.industryCodelist[i].subsetList[j].industryName
            }
          }
        }
      },
      changeCode(name) {
        this.$nextTick(() => {
          if (this[name] != null) {
            this[name] = this[name].replace(/[^\d.]/g,"");
            // 验证第一个字符是数字
            this[name] = this[name].replace(/^\./g,"");
            // 只保留第一个, 清除多余的
            this[name] = this[name].replace(/\.{2,}/g,".");
            this[name] = this[name].replace(".","$#$").replace(/\./g,"").replace("$#$",".");
            // 只能输入两个小数
            this[name] = this[name].replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');
          }
        });
      },
     diaSuccessEvt() {
      this.dialogOfferVisible = false;
       this.$message({
         message: '提交成功',
         type: "success",
         duration: 500
       });
      // this.diaShow = true;
      this.getProjectDetails();
    },
    judgePemmision(res){
      if(res.data.marginPayStatus==1){
        this.delistingStatus = '资料已提交</br>需要等待管理人员进行审核'
        this.applayShow = true
        return false
      }
      if(res.data.marginPayStatus==3){
        this.delistingStatus = '审核未通过</br>竞价资格审核未通过,请在"我的</br>申请"中重新发起申请'
        this.applayShow = true
        return false
      }
      if(res.data.marginPayStatus==2){
        this.delistingStatus = '审核已通过</br>请查看“我的申请”，支付保证金，参与竞价'
        this.applayShow = true
        return false
      }
      if(res.data.marginPayStatus==4){
        this.delistingStatus = '已支付保证金</br>需要等待管理人员审核到账状态'
        this.applayShow = true
        return false
      }
      if(res.data.marginPayStatus==6){
        this.delistingStatus = '保证金到账审核未通过</br>请查看“我的申请”，重新发起支付'
        this.applayShow = true
        return false
      }
      return true
    },
    // 出价
    async offerPrice(){
      this.loading = true
      const res = await this.$api.my.delistingGetDetail({ listingApplyId: this.data.id })
      this.loading = false
      if (this.$store.state.token == 'show') return
      if(res.data.isSubmitMaterial == 0){
        this.delistingStatus = '没有提交申请不能出价'
        this.applayShow = true
        return
      }
      // if(res.data.isMaterialAdopt == 0 || res.data.isMaterialAdopt == 2){
      //   this.delistingStatus = res.data.isMaterialAdopt == 0? '资料已提交<br/>需要等待管理人员进行审核':'资料已驳回，请修改后重新提交'
      //   this.applayShow = true
      //   return
      // }else if(res.data.isPromisePayed == 0){
      //   this.delistingStatus = '保证金待审核'
      //   this.applayShow = true
      //   return
      // }
      if(!this.judgePemmision(res)) return
      if (!this.quotedAmount) {
        return this.$message.error("请输入出价金额");
      } else {
        let minAmout = Number(this.data.maxReportAmount)
          ? Number(this.data.maxReportAmount) +
            Number(this.data.auctionInterval)
          : Number(this.data.listingPrice);
        if (minAmout > this.data.maxAmount) {
          minAmout = this.data.maxAmount;
        }
        if (this.quotedAmount < minAmout) {
          let a =
            Math.round(
              (Number(this.data.maxReportAmount) +
                Number(this.data.auctionInterval)) *
                100
            ) / 100;
          let b = Math.round(Number(this.data.listingPrice) * 100) / 100;
          this.contentMsg = `<p>出价金额不能低于:${
            this.data.maxReportAmount ? a + "元" : b + "元"
          }${
            this.data.maxReportAmount ? "(最高报价+竞价阶梯)" : "(起拍金额)"
          }</p>
                  <p>${
                    this.data.maxReportAmount
                      ? "最高报价为:" + this.data.maxReportAmount + "元"
                      : "起拍金额为:" + this.data.listingPrice + "元"
                  }</p>
                  <p> ${"竞价阶梯为:" + this.data.auctionInterval + "元"}</p>`;
          this.diaJjShow = true;
          return false;
        } else if (this.quotedAmount > this.data.maxAmount) {
          this.contentMsg = `<p>出价金额不能高于:${
            this.data.maxAmount + "元 (最高价)"
          }</p>
                  <p>${
                    this.data.maxReportAmount
                      ? "最高报价为:" + this.data.maxReportAmount + "元"
                      : "起拍金额为:" + this.data.listingPrice + "元"
                  }</p>
                  <p> ${"竞价阶梯为:" + this.data.auctionInterval + "元"}</p>`;
          this.diaJjShow = true;
          return false;
        } else {
          this.delistingData = res.data
          this.data.quotedAmount = this.quotedAmount
          this.dialogOfferVisible = true;
        }
      }
      // this.offerPriceTime = !this.offerPriceTime

      // if(this.offerPriceTime){
      //   this.bidding && this.getTimeAmountFn()
      // }
    },
    //判断按钮名字
    async judgeBtnText(){
      const res = await this.$api.my.delistingGetDetail({ listingApplyId: this.data.id })
      // if(res.data.isSubmitMaterial == 0){
      //   this.btnText = '意向报名'
      //   this.btnText2 = '意向报名'
      //   this.isSubmitMaterial = false
      // }
      if(this.data.tranferType == 1){
        if(res.data.marginPayStatus == 5){
          if(this.data.businessType=='7'){
            this.btnText2 = '此项目将在开始时间后在线下竞价，如已获得竞价资格，请准时到场并参与'
            this.isHanger = true
          }else {
            this.btnText2 = '出价'
          }
          this.isSubmitMaterial = true
        }else {
          this.btnText2 = '意向报名'
          this.isSubmitMaterial = false
        }
      }else {
        if(res.data.marginPayStatus ==2){
          this.btnText = '去付款'
          this.isSubmitMaterial = true
        }else {
          this.btnText = '意向报名'
          this.isSubmitMaterial = false
        }
      }
      if(this.routerStatus!=3){
        this.isSubmitMaterial = true
      }
  },
    // 申请摘牌
    async applicationDelisting(){
      if (!this.$store.state.userInfo.personVertification) {
        return (this.$store.state.vertification = true);
      }
      if (!this.checked&&!this.isSubmitMaterial){
        return this.$message.error(`请阅读公告信息并勾选已读，知晓交易要求并愿意承担由此产生的一切责任`);
      }
      this.loading = true
      const res = await this.$api.my.delistingGetDetail({ listingApplyId: this.data.id })
      this.loading = false
      if(res.data.isSubmitMaterial == 0){
        // if (this.ruleContent && !this.checked){
        //   // return this.$message.error(`请阅读并勾选《${this.transactionName}》`);
        //   return this.$message.error(`请阅读公告信息并勾选已读，知晓交易要求并愿意承担由此产生的一切责任`);
        // }
        this.businessType = this.data.businessType
        return this.delistingStartShow = true
      }
      if(res.data.marginPayStatus==1){
        this.delistingStatus = '资料已提交</br>需要等待管理人员进行审核'
        this.applayShow = true
        return
      }
      if(res.data.marginPayStatus==3){
        this.delistingStatus = '审核未通过</br>竞价资格审核未通过,请在"我的</br>申请"中重新发起申请'
        this.applayShow = true
        return
      }
      this.delistingShow = true
      this.delistingData = res.data
      // if(res.data.isMaterialAdopt == 0 || res.data.isMaterialAdopt == 2){
      //   this.delistingStatus = res.data.isMaterialAdopt == 0? '资料已提交<br/>需要等待管理人员进行审核':'资料已驳回，请修改后重新提交'
      //   this.applayShow = true
      // }else if(res.data.isMaterialAdopt == 1){
      //   // 报价
      //   this.delistingShow = true
      //   this.delistingData = res.data
      // }
    },
    getTimeAmountFn() {
      let timer2;
      this.getTimeAmount().then((isGetTime) => {
        clearInterval(timer2);
        if (isGetTime) {
          timer2 = setTimeout(() => {
          //  this.offerPriceTime && this.getTimeAmountFn();
           this.getTimeAmountFn();
          }, 1000);
        }
      });
      this.$once("hook:beforeDestroy", () => {
        clearInterval(timer2);
      });
    },
    dateFtt(fmt, dateString) {
      let date = new Date(dateString);
      let ret;
      let opt = {
          "Y+": date.getFullYear().toString(),        // 年
          "m+": (date.getMonth() + 1).toString(),     // 月
          "d+": date.getDate().toString(),            // 日
          "H+": date.getHours().toString(),           // 时
          "M+": date.getMinutes().toString(),         // 分
          "S+": date.getSeconds().toString()          // 秒
          // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
          ret = new RegExp("(" + k + ")").exec(fmt);
          if (ret) {
              fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
          }
      }
      return fmt;
    },
    async getTimeAmount() {
      if(!this.$route.query.id || !this.$route.query.type) return
      return await this.$api.my
        .getTimeAmount({
          applyId: this.$route.query.id,
          type: this.$route.query.type,
        })
        .then((res) => {
          let aTime;
          clearInterval(aTime);
          let isGetTime = true;
          this.maxReportAmount = res.data.maxReportAmount;
          this.data.auctionEndTime =  this.dateFtt('YYYY-mm-dd HH:MM:SS',res.data.auctionEndTime);

          if(res.data.userName && res.data.userName == this.$store.state.userInfo.name){
            this.userName = "本人"
          } else if (res.data.userName){
            this.userName = res.data.userName.substr(0,1) + '*'
          } else {
            this.userName = '--'
          }
          // this.userName = res.data.userName && res.data.userName == this.$store.state.userInfo.name ? '本人': res.data.userName.substr(0,1) + '*'
          if (res.data.auctionEndTime - this.isEndTime != 0) {
            this.isEndTime = res.data.auctionEndTime;
            this.deadline = this.dateFtt1(this.isEndTime);
            aTime = setInterval(() => {
              this.deadline = this.dateFtt1(this.isEndTime);
            }, 1000);
            // this.data.auctionEndTime =  dateFtt(res.data.auctionEndTime);
          }

          if (this.isEndTime - new Date().getTime() <= 0) {
            this.bidding = false;
            this.finish = true
            clearInterval(aTime);
            // this.getProjectDetails();
            window.location.reload()
            return (isGetTime = false);
          }
          return (isGetTime = true);
        });
    },
    dateFtt1(timer) {
      let myDate = new Date().getTime();
      let time = timer - myDate;
      if (time && time <= 0) {
        return { td: "00", th: "00", tm: "00", ts: "00", timeStatus: false };
      }
      let td = Math.floor(time / (1000 * 60 * 60 * 24)), //计算天数
        th = Math.floor((time / (1000 * 60 * 60)) % 24), //计算小时数
        tm = Math.floor((time / (1000 * 60)) % 60), //计算分钟数
        ts = Math.floor((time / 1000) % 60);
      td = td >= 10 ? td : "0" + td;
      th = th >= 10 ? th : "0" + th;
      tm = tm >= 10 ? tm : "0" + tm;
      ts = ts >= 10 ? ts : "0" + ts;
      return { td, th, tm, ts, timeStatus: true };
    },
    carouselChange(next, prev) {
      let maxLength = this.data&&this.data.imgList?this.data.imgList.length:0
      if (prev != next && maxLength) {
        if (this.miniCarouselBox < maxLength*this.miniPicture) {
          let miniCarouselContent = this.$refs.miniCarouselContent
          if (miniCarouselContent) {
            let marginLeft = Number(miniCarouselContent.style.marginLeft.replace('px',''))
            if ((next+1)*this.miniPicture+marginLeft<=0) {
              miniCarouselContent.style.marginLeft = -next*this.miniPicture+'px'
            } else if ((next+1)*this.miniPicture+marginLeft>this.miniCarouselBox) {
              miniCarouselContent.style.marginLeft = this.miniCarouselBox-(next+1)*this.miniPicture+'px'
            }
          }
        }
        this.miniActive = next
      }
    },
    changeCarousel(type) {
      let villageCarousel = this.$refs.villageCarousel,
      datas = this.data
      if (datas&&datas.imgList&&datas.imgList.length&&villageCarousel) {
        let miniCarouselContent = this.$refs.miniCarouselContent
        if (type == 'next') {
          let maxLength = datas.imgList.length*this.miniPicture
          if(miniCarouselContent&&(maxLength>this.miniCarouselBox)) {
            let marginLeft = Number(miniCarouselContent.style.marginLeft.replace('px',''))
            if (marginLeft+maxLength > this.miniCarouselBox) {
              let moreLength = marginLeft+maxLength-this.miniCarouselBox
              miniCarouselContent.style.marginLeft = marginLeft-(moreLength >= this.miniPicture?this.miniPicture:moreLength)+'px'
            }
          }
          if (this.miniActive != datas.imgList.length - 1) {
            this.miniActive += 1
            villageCarousel.next()
          }
          // this.miniActive = (this.miniActive == datas.imgList.length - 1)?0:(this.miniActive+1)
          // villageCarousel.next()
        } else {
          if(miniCarouselContent) {
            let marginLeft = Number(miniCarouselContent.style.marginLeft.replace('px',''))
            if (marginLeft!=0) {
              let moreLength = marginLeft+this.miniPicture
              miniCarouselContent.style.marginLeft = marginLeft+(moreLength <= 0?this.miniPicture:-marginLeft)+'px'
            }
          }
          if (this.miniActive) {
            this.miniActive -= 1
            villageCarousel.prev()
          }
          // this.miniActive = !this.miniActive?(datas.imgList.length-1):(this.miniActive-1)
          // villageCarousel.prev()
        }
      }
    },
    activeMiniFn(ind) {
      if (this.data&&this.data.imgList&&this.data.imgList.length) {
        let villageCarousel = this.$refs.villageCarousel
        if (villageCarousel) {
          villageCarousel.setActiveItem(ind)
        }
        this.miniActive = ind
      }
    },
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      if ( columnIndex == 0 || columnIndex == 1 || (columnIndex == 2 && rowIndex != (this.data.businessType == 1 ? this.tableDataNc.length- 1:this.data.businessType == 2 ? this.tableDataLq.length- 1:this.data.businessType == 7 ? this.tableDataHanger.length- 1 : this.tableDataCustom.length - 1)) ||columnIndex == 4 ) {
        return 'warning-row';
      }
      return '';
    },
    tableCellClassNames({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0 || columnIndex == 1) {
        return 'warning-row';
      }
      return '';
    },
    arrayMethods({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        if (rowIndex == 0) {
          return {
            rowspan: this.data.bidNotice.bidNoticDetail.length,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    arrayMethod({ row, column, rowIndex, columnIndex }) {
      let list = this.data.businessType == 1 ? this.tableDataNc  : this.data.businessType == 2 ? this.tableDataLq :this.data.businessType == 7 ? this.tableDataHanger: this.tableDataCustom
      let MainPartLength = this.listingMainPartList.length
      // console.log(rowIndex,row.name,columnIndex ,"===")
      // 当前行row、当前列column、当前行号rowIndex、当前列号 columnIndex 四个属性。
      // [rowspan: 1,    //合并一行  colspan: 2  ]  //合并两列
      if (columnIndex == 0) {
        if (rowIndex == 0) {
          return [list.length,1];
        } else {
          return [0, 0];
        }
      }
      if (columnIndex == 1) {
        if (rowIndex == 0) {
          return [list.length-1-MainPartLength,1];
        } else if ( rowIndex == list.length-1-MainPartLength ) {
          return [MainPartLength, 1];
        } else if ( rowIndex == list.length-1 ) {
          return [1, 1];
        }else {
          return [0, 0];
        }
      }
      if (columnIndex == 2) {
        if (rowIndex == list.length-1 ) {
          return [1, 4];
        }
      }
      // if (this.data.businessType == 2 ) {
      //   if (rowIndex == 0) {
      //     if (columnIndex == 3) {
      //       return [1, 3];
      //     } else if (columnIndex == 2) {
      //       return [1, 1];
      //     } else {
      //       return [0, 0];
      //     }
      //   }
      // }
      if (rowIndex == list.length-2-MainPartLength&&((this.data.businessType!=2&&!list[list.length-2-MainPartLength].marks)||(this.data.businessType==2&&this.data.propertychildtype==='0501'||this.data.propertychildtype==='0502'||this.data.propertychildtype==='0503'||this.data.propertychildtype==='0506'))) {
        if (columnIndex == 3) {
          return [1, 3];
        } else if (columnIndex == 2) {
          return [1, 1];
        } else {
          return [0, 0];
        }
      }
      if(!list[list.length-2].marks){
        if (rowIndex == list.length-2) {
          if (columnIndex == 3) {
            return [1, 3];
          } else if (columnIndex == 2) {
            return [1, 1];
          } else {
            return [0, 0];
          }
        }
      }
      if (this.data.businessType > 2 ) {
        if(!list[list.length-2-MainPartLength].marks){
          if (rowIndex == list.length-2-MainPartLength) {
          if (columnIndex == 3) {
            return [1, 3];
          } else if (columnIndex == 2) {
            return [1, 1];
          } else {
            return [0, 0];
          }
        }
        }
      }
    },
    beforeArrayMethod({ row, column, rowIndex, columnIndex }) {
       // console.log(rowIndex,row.name,columnIndex ,"===")
      // 当前行row、当前列column、当前行号rowIndex、当前列号columnIndex四个属性。
      // [rowspan: 1,    //合并一行  colspan: 2  ]  //合并两列
      if (columnIndex == 0) {
        if (rowIndex == 0) {
          return [this.data.businessType == 1 ? this.tableDataNc.length  : this.data.businessType == 2 ? this.tableDataLq.length : this.tableDataCustom.length,1, ];
        } else {
          return [0, 0];
        }
      }
      if (columnIndex == 1) {
        if (rowIndex == 0) {
          return [ this.data.businessType == 1 ? this.tableDataNc.length-1  : this.data.businessType == 2 ? this.tableDataLq.length-1 : this.tableDataCustom.length-1,1];
        } else if ( rowIndex == (this.data.businessType == 1 ? this.tableDataNc.length-1  : this.data.businessType == 2 ? this.tableDataLq.length-1 : this.tableDataCustom.length-1)) {
          return [1, 1];
        } else {
          return [0, 0];
        }
      }
      if (this.data.businessType ==2 ) {
        if (rowIndex == 0) {
          if (columnIndex == 3) {
            return [1, 3];
          } else if (columnIndex == 2) {
            return [1, 1];
          } else {
            return [0, 0];
          }
        }
      }
      if ( rowIndex == (this.data.businessType == 1 ? this.tableDataNc.length-1  : this.data.businessType == 2 ? this.tableDataLq.length-1 : this.tableDataCustom.length-1)) {
          if (columnIndex == 2) {
            return [1, 4];
          } else {
            return [0, 0];
          }
        }
      if(this.data.businessType > 2 ){
        if(!this.tableDataCustom[this.tableDataCustom.length-2].marks){
          if (rowIndex == this.tableDataCustom.length-2) {
            if (columnIndex == 3) {
              return [1, 3];
            } else if (columnIndex == 2) {
              return [1, 1];
            } else {
              return [0, 0];
            }
          }
        }
      }
    },
    async getRule() {
      this.Loading = true;
      // console.log(this.$store.state.cityArea.sonAreas[0].areaConfigId)
      // debugger
      await this.$api.my.RuleDetail({ areaConfigId: this.$store.state.cityArea.sonAreas[0].areaConfigId,ruleType:2 }).then((res) => {
        if (res.code == 1000 && res.data) {
          this.ruleContent = res.data.transactionContent || '';
          this.transactionViolate = res.data.transactionViolate || '';
          this.transactionName = res.data.transactionName || '';
        }
      }).finally(() => (this.Loading = false));
    },
    //意向报名
    async newDiaShowEvt(){
      if (!this.checked&&!this.isSubmitMaterial){
        return this.$message.error(`请阅读公告信息并勾选已读，知晓交易要求并愿意承担由此产生的一切责任`);
      }
      this.loading = true
      const res = await this.$api.my.delistingGetDetail({ listingApplyId: this.data.id })
      this.loading = false
      if (this.$store.state.token == 'show') return
      if(res.data.isSubmitMaterial == 0){
        return this.diaShowEvt()
      }
      // if(res.data.isMaterialAdopt == 0 || res.data.isMaterialAdopt == 2){
      //   this.delistingStatus = res.data.isMaterialAdopt == 0? '资料已提交<br/>需要等待管理人员进行审核':'资料已驳回，请修改后重新提交'
      //   this.applayShow = true
      //   return
      // }else if(res.data.isPromisePayed == 0 && this.data.businessTypeDesc != '增减挂钩'){
      //   this.delistingStatus = '保证金待审核'
      //   this.applayShow = true
      //   return
      // }else if(res.data.isMaterialAdopt == 1 && this.data.businessTypeDesc == '增减挂钩'){
      //     this.delistingStatus = '资料已审核通过'
      //   this.applayShow = true
      //   return
      // }
      //marginPayStatus
      //0 资料待提交  1.资料待审核  2.资料审核通过（待支付保证金） 3.资料审核不通过
      //  4.已支付保证金待审核  5.保证金审核通过 6.保证金未到账
      // if(res.data.marginPayStatus==0){
      //   if((new Date(this.data.applyEndTime).getTime())<(new Date().getTime())){
      //     return this.$message.error('报名已经结束')
      //   }
      // }
      if(!this.judgePemmision(res)) return
      if(this.data.businessTypeDesc == '增减挂钩') return
      const nowDate = new Date().getTime();
      let stratDate = '';
      let endDate = '';
      if (this.data.tranferType == 1) {
        stratDate = new Date(this.data.auctionStartTime).getTime();
        endDate = new Date(this.data.auctionEndTime).getTime();
      } else {
        stratDate = new Date(this.data.applyTime).getTime();
        endDate = new Date(this.data.endTime).getTime();
      }
      if(this.data.tranferType == 1){
        if (stratDate > nowDate) return this.$message.error('时间还未开始');
        if (stratDate < nowDate && endDate > nowDate) {
          this.isStart = true
          this.bidding = true;
          this.getTimeAmount();
        }
      }

      // }else if(res.data.isMaterialAdopt == 1){
      //   // 报价
      //   this.delistingShow = true
      //   this.delistingData = res.data
      // }
    },
    diaShowEvt() {
      // this.$message.error('该功能还在开发中');
      // return
      if (this.routerStatus != 3) return false;
      if (!this.$store.state.token || this.$store.state.token == 'show') {
        sessionStore.remove('zctToken');
        this.$store.dispatch('getToken', 'show');
        // this.$router.push('/home');
        return;
      }
      // 未认证
      if (!this.$store.state.userInfo.personVertification) {
        // this.$store.commit('setVertification',true)
        // return
        return (this.$store.state.vertification = true);
      }
      // if (this.ruleContent && !this.checked)
      //   // return this.$message.error(`请阅读并勾选《${this.transactionName}》`);
      //   return this.$message.error(`请阅读公告信息并勾选已读，知晓交易要求并愿意承担由此产生的一切责任`);
      const nowDate = new Date().getTime();
      let stratDate = '';
      let endDate = '';
      if (this.data.tranferType == 1) {
        stratDate = new Date(this.data.auctionStartTime).getTime();
        endDate = new Date(this.data.auctionEndTime).getTime();
      } else {
        stratDate = new Date(this.data.applyTime).getTime();
        endDate = new Date(this.data.endTime).getTime();
      }
      if((new Date(this.data.applyEndTime).getTime())<(new Date().getTime())){
        return this.$message.error('报名已经结束')
      }
      // if (stratDate > nowDate) return this.$message.error('时间还未开始');
      if (endDate < nowDate) return this.$message.error('时间已经结束');
      if (this.transactionViolate) {
        this.ruleTipDiaShow = true;
      } else {
        this.dialogVisible = true;
      }
    },
    // 获取项目详情
    async getProjectDetails() {
      this.Loading = true;
      await this.$api.my.delistingDetail({
          applyId: this.$route.query.id,
          type: this.$route.query.type,
        }).then((res) => {
          if (res.code == 1000) {
            sessionStore.set("paramInfo",res.data)
            this.$set(res.data.bidNotice.bidNoticDetail[0],'name',res.data.tranferType == 1 ? '竞买公告' : '交易公告');
            this.data = res.data;
            if (this.data.tranferType == 1){
              this.isApplyStart = new Date(this.data.applyStartTime.replace(/\-/g,'/')).getTime()<=new Date().getTime()
              this.isApplyEnd = new Date(this.data.applyEndTime.replace(/\-/g,'/')).getTime()<=new Date().getTime()
            }else {
              this.isApplyStart = true
            }
            this.roleFileList = res.data.fileList;
            // this.routerStatus = this.$route.query.status != this.data.status ? this.data.status : this.$route.query.status
            this.routerStatus = this.data.status
            this.newStatus = this.data.newStatus
            this.roleFileList.forEach((item) => {
              this.$set(item, 'status', true);
              this.$set(item, 'fileList', []);
              if (item.maxNumber == 1) {
                item.fileList.push({
                  fileName: item.fileName,
                  fileUrl: item.fileUrl ? item.fileUrl[0] : '',
                  fileType: item.fileType,
                });
              } else {
                item.fileUrl.forEach((i) => {
                  item.fileList.push({
                    fileName: item.fileName,
                    fileUrl: i ? i : '',
                    fileType: item.fileType,
                  });
                });
              }
            });
            let arr = []
            if(this.data.listingMainPart && this.data.listingMainPart.identityType){
              let data = JSON.parse(JSON.stringify(this.data.listingMainPart))
              Object.keys(data).forEach((key,item) => {
                if (data[key]) {
                  if(key == 'name'){
                    if (data.identityType ==='01') {
                      arr.push({fieldValue: data[key],fieldName:'企业事业单位'})
                    } else if (data.identityType ==='02') {
                      arr.push({fieldValue: `${data[key].substr(0, 1)}**`,fieldName:'自然人'})
                    }
                  }else if (key == 'creditCode'){
                    arr.push({fieldValue: `${data[key].substr(0, 4)}**********${data[key].substr(-4)}`, fieldName: '统一信用代码'})
                  }else if (key == 'registAddrss'){
                    arr.push({ fieldValue: data[key],fieldName: '注册地址'})
                  }else if (key == 'legalName'){
                    arr.push({fieldValue: `${data[key].substr(0, 1)}**`, fieldName: '法定代表人'})
                  }else if (key == 'contactPerson'){
                    arr.push({fieldValue: `${data[key].substr(0, 1)}**`,fieldName: '联系人' })
                  }else if (key == 'contactNumber'){
                    arr.push({fieldValue: `${data[key].substr(0, 3)}****${data[key].substr(-4)}`,fieldName: '联系电话' })
                  }else if (key == 'contactAddress'){
                    arr.push({fieldValue: data[key], fieldName: '联系地址' })
                  } else if (key == 'idNumber'){
                    arr.push({fieldValue: `${data[key].substr(0, 4)}**********${data[key].substr(-4)}`, fieldName: '身份证号' })
                  }else if (key == 'transferType'){
                    arr.push({fieldValue: data[key]==='01'?'国有企业':data[key]==='02'?'行政事业':data[key]==='99'?'其他':'', fieldName: '转让方类型'})
                  }else if (key == 'companyProperties'){
                    arr.push({fieldValue: this.companyPropertiesList[data[key]], fieldName: '企业性质'})
                  }else if (key == 'companyType'){
                    arr.push({fieldValue: this.companyTypeList[data[key]], fieldName: '企业类型'})
                  }else if (key == 'economicScale'){
                    arr.push({fieldValue: this.economicScaleList[data[key]], fieldName: '经济规模'})
                  }else if (key == 'companyIndustryCode'){
                    arr.push({fieldValue: this.getCodeLabel(data[key]), fieldName: '所属行业'})
                  }else if (key == 'sourceFund'){
                    arr.push({fieldValue: this.sourceFundList[data[key]], fieldName: '资金来源'})
                  }else{}
                }
              });
              arr.forEach((item,index) => {
                if(index % 2 === 0 ){
                  if(index == 0 ){
                    this.listingMainPartList.push({ name: '主体信息',mark: '', value: '', marks: '', values: ''})
                  } else {
                    this.listingMainPartList.push({mark: '', value: '', marks: '', values: ''})
                  }
                  this.listingMainPartList[this.listingMainPartList.length-1].mark = item.fieldName
                  this.listingMainPartList[this.listingMainPartList.length-1].value = item.fieldValue
                } else {
                  this.listingMainPartList[this.listingMainPartList.length-1].marks = item.fieldName
                  this.listingMainPartList[this.listingMainPartList.length-1].values = item.fieldValue
                }
              })
            }
            if (this.data.businessType == 1) {
              if(this.data.circulWay==='CZ'){
                this.tableDataNc.splice(1,0, {
                  mark: '流转期限',
                  value: '',
                  marks: '承租押金',
                  values: '',
                },{
                  mark: '免租期限',
                  value: '',
                  marks: '租金递增方式',
                  values: '',
                })
              }
              if(this.data.isOtherRightsHolder==1){
                this.tableDataNc[this.tableDataNc.length-2].marks = '他项权利人'
                this.tableDataNc[this.tableDataNc.length-2].values = ''
                this.tableDataNc.splice(this.tableDataNc.length-1,0, {
                  mark: '他项权利内容',
                  value: ''
                })
              }
              this.tableDataNc.forEach((item) => {
                if (item.mark == '项目名称')  item.value = res.data.name;
                if (item.marks == '流转方式')  item.values = res.data.circulWay==='ZR'?'转让':res.data.circulWay==='CZ'?'出租':'';
                if (item.mark == '流转期限')  item.value = res.data.transferPeriod;
                if (item.marks == '承租押金')  item.values = res.data.czprice+ '元';
                if (item.mark == '免租期限')  item.value = res.data.rentFreePeriod;
                if (item.marks == '租金递增方式')  item.values = res.data.zujindizengtype;
                if (item.mark == '标的名称')  item.value = res.data.objectName;
                if (item.marks == '标的坐落所在地区')  item.values = res.data.location;
                if (item.mark == '权属类型')  item.value = this.ownershipTypeOption[res.data.ownershipType];
                if (item.marks == '标的类别')  item.values = this.propertychildtypeOption[res.data.propertychildtype];
                if (item.mark == '持有面积')item.value = res.data.holdArea + this.holdAreaList[res.data.holdAreaUnit];
                if (item.marks == '土地四至') item.values = res.data.fourSide;
                if (item.mark == '土地类型')  item.value = res.data.landType;
                if (item.marks == '土地用途')  item.values = res.data.usePurpose;
                if (item.mark == '使用期限')  item.value = res.data.czqx;
                if (item.marks == '承包权人')  item.values = res.data.owner;
                if (item.mark == '经营权人')  item.value = res.data.tudimanager;
                if (item.marks == '权证名称')  item.values = res.data.warrantName;
                if (item.mark == '权证编号')  item.value = res.data.quanzhengno;
                if (item.marks == '权证年限(年)')  item.values = res.data.warrantTerm;
                // if (item.mark == '承包方式') item.value = res.data.contractingMode == '其他' ? res.data.otherContractingMode : res.data.contractingMode;
                if (item.mark == '转出方式')
                  item.value = res.data.transferMethod==='01'?'转让':res.data.transferMethod==='02'?'转包':'';
                if (item.marks == '是否属于再次转出')
                  item.values = res.data.isReTransfer == 1 ? '是' : '否';
                // if (item.marks == '是否有优先受让方')
                //   item.values = res.data.isPriorTransfer == 1 ? '是' : '否';
                if (item.mark == '是否存在他项权利人')
                  item.value = res.data.isOtherRightsHolder == 1 ? '是' : '否';
                if (item.marks == '他项权利人')
                  item.values = res.data.otherRightsHolder;
                if (item.mark == '他项权利内容')
                  item.value = res.data.otherRightsContent;
                // if (item.marks == '相关人员是否放弃优先权')
                //   item.values = res.data.isGiveUpAdvanceRight == 1 ? '是' : '否';
              });
             if(this.listingMainPartList.length) this.tableDataNc.splice(this.tableDataNc.length-1, 0 ,...this.listingMainPartList )
            } else if (this.data.businessType == 2) {
              if(this.data.circulWay==='CZ'){
                this.tableDataLq.splice(1,0, {
                  mark: '流转期限',
                  value: '',
                  marks: '承租押金',
                  values: '',
                },{
                  mark: '免租期限',
                  value: '',
                  marks: '租金递增方式',
                  values: '',
                })
              }
              //林木
              if(this.data.propertychildtype==='0501'){
                this.tableDataLq.splice(this.tableDataLq.length-1,0, {
                  mark: '品类',
                  value: '',
                  marks: '数量',
                  values: ''
                },{
                  mark: '标的物存放地',
                  value: '',
                  marks: '标的物现状',
                  values: ''
                },{
                  mark: '是否存在他项权利人',
                  value: ''
                })
              }
              //活力木
              if(this.data.propertychildtype==='0502'){
                this.tableDataLq.splice(this.tableDataLq.length-1,0, {
                  mark: '林地面积',
                  value: '',
                  marks: '林地起源',
                  values: ''
                },{
                  mark: '树龄',
                  value: '',
                  marks: '平均胸径',
                  values: ''
                },{
                  mark: '平均树高',
                  value: '',
                  marks: '树种',
                  values: ''
                },{
                  mark: '预计产量',
                  value: '',
                  marks: '产量单位',
                  values: ''
                },{
                  mark: '是否存在他项权利人',
                  value: ''
                })
              }
              //原木
              if(this.data.propertychildtype==='0503'){
                this.tableDataLq.splice(this.tableDataLq.length-1,0, {
                  mark: '树种',
                  value: '',
                  marks: '数量',
                  values: ''
                },{
                  mark: '是否存在他项权利人',
                  value: ''
                })
              }
              //地上林产品
              if(this.data.propertychildtype==='0504'){
                this.tableDataLq.splice(this.tableDataLq.length-1,0, {
                  mark: '林产品名称',
                  value: '',
                  marks: '林地面积',
                  values: ''
                },{
                  mark: '树种',
                  value: '',
                  marks: '预计产量',
                  values: ''
                },{
                  mark: '产量单位',
                  value: '',
                  marks: '是否存在他项权利人',
                  values: ''
                })
              }
              //林地承包经营权
              if(this.data.propertychildtype==='0505'){
                this.tableDataLq.splice(this.tableDataLq.length-1,0, {
                  mark: '林地面积',
                  value: '',
                  marks: '林地用途',
                  values: ''
                },{
                  mark: '树龄',
                  value: '',
                  marks: '平均胸径',
                  values: ''
                },{
                  mark: '平均树高',
                  value: '',
                  marks: '林权期限',
                  values: ''
                },{
                  mark: '树种',
                  value: '',
                  marks: '是否存在他项权利人',
                  values: ''
                })
              }
              //其他林产品
              if(this.data.propertychildtype==='0506'){
                this.tableDataLq.splice(this.tableDataLq.length-1,0, {
                  mark: '林产品类别',
                  value: '',
                  marks: '数量',
                  values: ''
                },{
                  mark: '是否存在他项权利人',
                  value: ''
                })
              }
              if(this.data.isOtherRightsHolder==1){
                if(this.data.propertychildtype==='0501'||this.data.propertychildtype==='0502'||this.data.propertychildtype==='0503'||this.data.propertychildtype==='0506'){
                  this.tableDataLq[this.tableDataLq.length-2].marks = '他项权利人'
                  this.tableDataLq[this.tableDataLq.length-2].values = ''
                  this.tableDataLq.splice(this.tableDataLq.length-1,0, {
                    mark: '他项权利内容',
                    value: ''
                  })
                }else if(this.data.propertychildtype==='0504'||this.data.propertychildtype==='0505'){
                  this.tableDataLq.splice(this.tableDataLq.length-1,0, {
                    mark: '他项权利人',
                    value: '',
                    marks: '他项权利内容',
                    values: ''
                  })
                }
              }
              this.tableDataLq.forEach((item) => {
                if (item.mark == '项目名称')  item.value = res.data.name;
                if (item.marks == '流转方式')  item.values = res.data.circulWay==='ZR'?'转让':res.data.circulWay==='CZ'?'出租':'';
                if (item.mark == '流转期限')  item.value = res.data.transferPeriod;
                if (item.marks == '承租押金')  item.values = res.data.czprice+ '元';
                if (item.mark == '免租期限')  item.value = res.data.rentFreePeriod;
                if (item.marks == '租金递增方式')  item.values = res.data.zujindizengtype;
                if (item.mark == '标的名称')  item.value = res.data.objectName;
                if (item.marks == '标的坐落所在地区')  item.values = res.data.location;
                if (item.mark == '权属类型')  item.value = this.ownershipTypeOption[res.data.ownershipType];
                if (item.marks == '标的类别')  item.values = this.forestRightCategory[res.data.propertychildtype];
                // if (item.mark == '标的坐落所在地区') item.value = res.data.location;
                // if (item.mark == '林地属性')
                //   item.value = res.data.forestAttr == 1 ? '国有' : res.data.forestAttr == 2 ? '非国有' : '';
                // if (item.marks == '占地面积') item.values = res.data.holdArea + (res.data.holdAreaUnit ? res.data.holdAreaUnit:'亩');;
                // if (item.mark == '林木蓄积(立方米)') item.value = res.data.forestStock;
                // if (item.marks == '树种') item.values = res.data.treeType;
                //林木
                if(this.data.propertychildtype==='0501'){
                  if (item.mark == '品类')  item.value = res.data.biaoditype;
                  if (item.marks == '数量')  item.values = res.data.holdArea + this.holdAreaList[res.data.holdAreaUnit];
                  if (item.mark == '标的物存放地')  item.value = res.data.cunfangaddress;
                  if (item.marks == '标的物现状')  item.values = res.data.remark;
                }
                //活立木
                if(this.data.propertychildtype==='0502'){
                  if (item.mark == '林地面积')  item.value = res.data.holdArea + this.holdAreaList[res.data.holdAreaUnit];
                  if (item.marks == '林地起源')  item.values = res.data.ldqy;
                  if (item.mark == '树龄')  item.value = res.data.sl + '年';
                  if (item.marks == '平均胸径')  item.values = res.data.pjxj + '厘米';
                  if (item.mark == '平均树高')  item.value = res.data.pjxg + '米';
                  if (item.marks == '树种')  item.values = res.data.treeType;
                  if (item.mark == '预计产量')  item.value = res.data.yjcl;
                  if (item.marks == '产量单位')  item.values = res.data.forestUnit;
                }
                //原木
                if(this.data.propertychildtype==='0503'){
                  if (item.mark == '树种')  item.value = res.data.treeType;
                  if (item.marks == '数量')  item.values = res.data.holdArea + this.holdAreaList[res.data.holdAreaUnit];
                }
                //地上林产品
                if(this.data.propertychildtype==='0504'){
                  if (item.mark == '林产品名称')  item.value = res.data.lcplb;
                  if (item.marks == '林地面积')  item.values = res.data.holdArea + this.holdAreaList[res.data.holdAreaUnit];
                  if (item.mark == '树种')  item.value = res.data.treeType;
                  if (item.marks == '预计产量')  item.values = res.data.yjcl;
                  if (item.mark == '产量单位')  item.value = res.data.forestUnit;
                }
                //林地承包经营权
                if(this.data.propertychildtype==='0505'){
                  if (item.mark == '林地面积')  item.value = res.data.holdArea + this.holdAreaList[res.data.holdAreaUnit];
                  if (item.marks == '林地用途')  item.values = res.data.ldyt;
                  if (item.mark == '树龄')  item.value = res.data.sl + '年';
                  if (item.marks == '平均胸径')  item.values = res.data.pjxj + '厘米';
                  if (item.mark == '平均树高')  item.value = res.data.pjxg + '米';
                  if (item.marks == '林权期限')  item.values = res.data.lqqx;
                  if (item.mark == '树种')  item.value = res.data.treeType;
                }
                //其他林产品
                if(this.data.propertychildtype==='0506'){
                  if (item.mark == '林产品类别')  item.value = res.data.lcplb;
                  if (item.marks == '数量')  item.values = res.data.holdArea + this.holdAreaList[res.data.holdAreaUnit];
                }
                if(this.data.propertychildtype==='0501'||this.data.propertychildtype==='0502'||this.data.propertychildtype==='0503'||this.data.propertychildtype==='0506'){
                  if (item.mark == '是否存在他项权利人')
                    item.value = res.data.isOtherRightsHolder == 1 ? '是' : '否';
                  if (item.marks == '他项权利人')
                    item.values = res.data.otherRightsHolder;
                  if (item.mark == '他项权利内容')
                    item.value = res.data.otherRightsContent;
                }else if(this.data.propertychildtype==='0504'||this.data.propertychildtype==='0505'){
                  if (item.marks == '是否存在他项权利人')
                    item.values = res.data.isOtherRightsHolder == 1 ? '是' : '否';
                  if (item.mark == '他项权利人')
                    item.value = res.data.otherRightsHolder;
                  if (item.marks == '他项权利内容')
                    item.values = res.data.otherRightsContent;
                }
              });
              if(this.listingMainPartList.length)this.tableDataLq.splice(this.tableDataLq.length-1, 0 ,...this.listingMainPartList )
            }else if(this.data.businessType == 7){
              if(this.data.isOtherRightsHolder==1){
                this.tableDataHanger[this.tableDataHanger.length-2].marks = '他项权利人'
                this.tableDataHanger[this.tableDataHanger.length-2].values = ''
                this.tableDataHanger.splice(this.tableDataHanger.length-1,0, {
                  mark: '他项权利内容',
                  value: ''
                })
              }
              this.tableDataHanger.forEach(item => {
                if (item.mark == '标的名称')  item.value = res.data.name;
                if (item.marks == '标的使用范围')  item.values = res.data.location;
                if (item.mark == '标的数量')  item.value = res.data.number;
                if (item.marks == '标的单位')  item.values = res.data.unit;
                if (item.mark == '流转期限')  item.value = res.data.transferPeriod;
                if (item.marks == '流转方式')  item.values = res.data.transferMethod;
                if (item.mark == '是否存在他项权利人')
                  item.value = res.data.isOtherRightsHolder == 1 ? '是' : '否';
                if (item.marks == '他项权利人')
                  item.values = res.data.otherRightsHolder;
                if (item.mark == '他项权利内容')
                  item.value = res.data.otherRightsContent;
              })
              if(this.listingMainPartList.length)this.tableDataHanger.splice(this.tableDataHanger.length-1, 0 ,...this.listingMainPartList )
            } else {
              if(this.data.circulWay==='CZ'){
                this.tableDataCustom.splice(2,0, {
                  mark: '流转期限',
                  value: '',
                  marks: '承租押金',
                  values: '',
                },{
                  mark: '免租期限',
                  value: '',
                  marks: '租金递增方式',
                  values: '',
                })
              }
              if(this.data.isOtherRightsHolder==1){
                this.tableDataCustom[this.tableDataCustom.length-2].marks = '他项权利人'
                this.tableDataCustom[this.tableDataCustom.length-2].values = ''
                this.tableDataCustom.splice(this.tableDataCustom.length-1,0, {
                  mark: '他项权利内容',
                  value: ''
                })
              }
              this.tableDataCustom.forEach((item) => {
                if (item.mark == '自定义类型') item.value = this.areaStatus.find(item=>item.id===res.data.businessType).type;
                if (item.marks == '项目名称') item.values = res.data.name;
                if (item.mark == '标的名称') item.value = res.data.objectName;
                if (item.marks == '流转方式') item.values = res.data.circulWay==='ZR'?'转让':res.data.circulWay==='CZ'?'出租':'';
                if (item.mark == '流转期限')  item.value = res.data.transferPeriod;
                if (item.marks == '承租押金')  item.values = res.data.czprice+ '元';
                if (item.mark == '免租期限')  item.value = res.data.rentFreePeriod;
                if (item.marks == '租金递增方式')  item.values = res.data.zujindizengtype;
                if (item.mark == '标的坐落所在地区') item.value = res.data.location;
                if (item.marks == '权属类型') item.values = this.ownershipTypeOption[res.data.ownershipType];
                if (item.mark == '标的数量') item.value = res.data.number;
                if (item.marks == '标的单位') item.values = this.customUnitOption[res.data.unit];
                // if (item.marks == '转让期限') item.values = res.data.transferPeriod;
                if (item.mark == '是否存在他项权利人') item.value = res.data.isOtherRightsHolder == 1 ? '是' : '否';
                if (item.marks == '他项权利人') item.values = res.data.otherRightsHolder;
                if (item.mark == '他项权利内容') item.value = res.data.otherRightsContent;
              });
              console.log(555,this.data.customFields)
              if(this.data.customFields){
                this.data.customFields.forEach((item,index) =>{
                  if(index % 2 === 0 ){
                    this.tableDataCustom[this.tableDataCustom.length-2].marks = item.fieldName
                    if(item.fieldName==='设备类型'){
                      this.tableDataCustom[this.tableDataCustom.length-2].values = this.deviceTypeList[item.fieldValue]
                    }else if(item.fieldName==='房产类型'){
                      this.tableDataCustom[this.tableDataCustom.length-2].values = this.propertyTypeList[item.fieldValue]
                    }else if(item.fieldName==='配备电梯'){
                      this.tableDataCustom[this.tableDataCustom.length-2].values = this.whetherList[item.fieldValue]
                    } else {
                      this.tableDataCustom[this.tableDataCustom.length-2].values = item.fieldValue
                    }
                  } else {
                    this.tableDataCustom.splice(this.tableDataCustom.length-1, 0 , {mark: '', value: '', marks: '', values: ''} )
                    this.tableDataCustom[this.tableDataCustom.length-2].mark = item.fieldName
                    if(item.fieldName==='设备类型'){
                      this.tableDataCustom[this.tableDataCustom.length-2].value = this.deviceTypeList[item.fieldValue]
                    }else if(item.fieldName==='房产类型'){
                      this.tableDataCustom[this.tableDataCustom.length-2].value = this.propertyTypeList[item.fieldValue]
                    }else if(item.fieldName==='配备电梯'){
                      this.tableDataCustom[this.tableDataCustom.length-2].value = this.whetherList[item.fieldValue]
                    } else {
                      this.tableDataCustom[this.tableDataCustom.length-2].value = item.fieldValue
                    }
                  }
                })
              }
              if(this.listingMainPartList.length)this.tableDataCustom.splice(this.tableDataCustom.length-1, 0 ,...this.listingMainPartList )
            }
            let stratDate = "";
            let endDate = null;
            let nowDate = new Date().getTime();
            if (this.data.tranferType == 1) {
              stratDate = new Date(this.data.auctionStartTime).getTime();
              endDate = new Date(this.data.auctionEndTime).getTime()
              //定时比较报名开始时间和结束时间
                this.timer = setInterval(() => {
                if(this.isApplyEnd){
                  clearInterval(this.timer)
                }else {
                  this.isApplyStart = new Date(this.data.applyStartTime.replace(/\-/g,'/')).getTime()<=new Date().getTime()
                  this.isApplyEnd = new Date(this.data.applyEndTime.replace(/\-/g,'/')).getTime()<=new Date().getTime()
                }
              },1000)
              if(stratDate > nowDate ){
                let aTime;
                clearInterval(aTime);
                let sTime = stratDate - nowDate
                aTime = setInterval(() => {
                  if(sTime <= 1000 && this.data.businessTypeDesc != '增减挂钩'){
                    this.isStart = true
                    this.bidding = true;
                    this.getTimeAmount();
                    // this.$api.my.delistingGetDetail({ listingApplyId: this.data.id }).then(res => {
                    //   this.delistingData = res.data
                    // })
                  }
                   sTime -= 1000
                },1000)
              } else{
                this.isStart = true
              }
            } else {
              stratDate = new Date(this.data.applyTime).getTime();
              endDate = new Date(this.data.endTime).getTime()
            }

            if (endDate < nowDate ) {
              this.finish = true
            }
            // if (stratDate > nowDate) {
            //   this.isStart = true
            // }
            if(this.data.tranferType ==1 && !this.finish){
               // this.$api.my.delistingGetDetail({ listingApplyId: this.data.id }).then( res => {
               //   if(
               //        nowDate > stratDate &&
               //        nowDate < endDate && this.data.businessTypeDesc != '增减挂钩')
               //    {
               //      this.isStart = true
               //      this.delistingData = res.data
               //      this.bidding = true;
               //      this.getTimeAmount();
               //   }
               // })
              if(
                  nowDate > stratDate &&
                  nowDate < endDate && this.data.businessTypeDesc != '增减挂钩')
              {
                this.isStart = true
                this.bidding = true;
                this.getTimeAmount();
              }
            }
            // if (
            //   this.data.tranferType == 1 &&
            //   nowDate > stratDate &&
            //   nowDate < endDate
            // ) {
            //   this.bidding = true;
            //   this.getTimeAmount();
            // }
          }
        }).catch((error) => {}).finally(() => {
          this.Loading = false;
        });
    },
    diaSccessEvt() {
      this.dialogVisible = false;
      this.diaShow = true;
    },
    dialogSumbitL() {
      if (this.diaShow) {
        this.dialogVisible = false;
        this.diaShow = false;
        // this.$router.push({ name: 'Home' });
        // this.bidding = false
      } else {
        this.ruleDiaShow = false;
      }
      if(this.applayShow){
        this.applayShow = false
      }
    },
    dialogSumbitNew(){
      this.$router.push({name: 'myHanger'})
    },
    dialogSumbitR() {
      this.dialogVisible = false;
      this.diaShow = false;
      if (this.data.tranferType == 1) {
        this.$router.push({ name: 'myAuction' });
      } else {
        this.$router.push({ name: 'myInvest' });
      }
    },
  },
  async mounted() {
    this.index = this.$route.query.index;
    // this.routerStatus = this.$route.query.status
    // this.newStatus = this.$route.query.newStatus
    this.headerList[1].path = `/Subnav/exchange-project?index=${this.index}`;
    window.scrollTo(0, 0);
    await this.getIndustryCodeList()
    await this.getAreaStatus()
    await this.getProjectDetails();
     // await this.getRule();
    if (sessionStore.get('zctToken')) {
      this.judgeBtnText();
    }
    this.bidding && this.getTimeAmountFn()
    if(this.routerStatus!=3){
      this.isSubmitMaterial = true
    }
  },
  destroyed() {
    clearInterval(this.timer)
  }
};
</script>
<style lang="scss">
.price-box02{
  background-image:url(~@/assets/price-lang.png);
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  .title{
    font-size: 14px;
    color: #666666;
    margin-left: 13px;
    margin-right: 12px;
  }
  .price{
    font-size: 16px;
    color: #F44336;
    margin: 10px 0;
    span{
      font-size: 20px;
    }
  }
}
.price-box-wrap{
  display: flex;
  flex-direction: row;
  .state-box{
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #636363;
    &.red{
      background-color: #148257;
    }
    &>div{
      display: flex;
      flex-direction: row;
      align-items: center;
      img{
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }
    width: 116px;
    font-size: 16px;
    color: #fff;
  }
}
.warning-row {
  background: #f8f9fb !important;
}
.html-table-wrap {
  overflow: auto;
  /deep/ table {
    width: 100%;
  }
}
.warning-header {
  /deep/ th {
    font-size: 14px;
    color: #394259;
    background-color: #f8f9fb !important;
  }
}
.el-step__icona {
  background-image: url(~@/assets/processing@2x.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 20px;
  height: 20px;
  display: inline-block;
}
</style>
<style lang="scss" scoped>
.border-box{
}
//轮播
.el-carousel-wrap {
  // width: 408px;
  // height: 308px;
  width: 492px;
  // height: 372px;
  /deep/ .el-carousel__arrow {
    height: 47px;
    width: 30px;
    border-radius: 0px 2px 2px 0px;
    background: rgba(0,0,0,0.50);
  }
  /deep/ .el-carousel__arrow--right {
    right: 0;
  }
  /deep/ .el-carousel__arrow--left {
    left: 0;
  }
  .banner {
    // width: 408px;
    width: 492px;
    /deep/ .el-carousel__item {
      img {
        width: 100%;
        height: 100%;
      }
    }
    .flag {
      // width: 408px;
      width: 492px;
      height: 36px;
      line-height: 36px;
      background: rgba(0, 0, 0, 0.5);
      text-align: center;
      font-size: 14px;
      color: #fff;
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 20px;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
}
.container-main {
  margin: 0 auto;
  background: #fff;
  // width: 1200px;
  width: 1170px;
  padding: 30px 60px;
  h2 {
    font-size: 22px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    line-height: 30px;
    color: #394259;
    margin: 0 0 5px;
    text-align: center;
  }
  .el-divider {
    background-color: #ebecef;
  }
  .flex-start {
    padding: 6px 0;
    > div {
      display: flex;
      align-items: center;
      width: 50%;
      text-align: justify;
      text-justify: inter-ideograph;
      > span:first-child {
        min-width: 112px;
        text-align: left;
        display: inline-block;
        font-size: 14px;
        color: #60697e;
      }
      > span:last-child {
        font-size: 14px;
        color: #394259;
      }
      >div{
        color: #158f5f;
      }
    }
  }
  .box2{
    .flex-row{
      padding: 6px 0;
      &>div>div{
        display: flex;
      }
    }
    .mw{
      min-width: 112px;
    }
  }
  .must {
    font-size: 20px;
    line-height: 42px;
    color: red !important;
    font-weight: 600;
  }
  .must_small {
    color: red !important;
  }
  .step02-box .el-step:nth-of-type(1) {
    /deep/ .el-step__line {
      background-color: #22C686;
    }
  }
  .el-steps {
    // width: 650px;
    margin: 10px 50px 8.6px;
    // margin: 50px auto 30px;
    .el-step {
      /deep/ i {
        color: #C0C4CC;
        &.el-icon-success{
          color: #22c686;
        }
      }
      /deep/ .el-step__icon {
        width: 20px;
      }
      /deep/ .el-step__title {
        font-weight: 400;
        // color:#A8AAAE;
        font-size: 12px;
      }
      &:nth-of-type(3) {
        /deep/ .el-step__line {
          //background-color: #ebecef;
        }
        /deep/ .is-process {
          //color: #C0C4CC;
        }
      }
      &:nth-of-type(3) {
        /deep/ .el-step__main {
          text-align: right;
          transform: translateX(-80%);
        }
        /deep/ .is-process {
          //color: #a8aaae;
        }
        /deep/ .el-step__icon {
          //width: 12px;
        }
      }
    }
  }
  .finish {
    .el-step {
      /deep/ &:nth-of-type(4) {
        i {
          color: #22C686;
        }
      }
    }
  }
  .ApplyInvestment {
    font-size: 18px;
    width: 320px;
    height: 56px;
    margin-top: 32px;
    background: linear-gradient(
      135deg,
            #22C686,
            #158f5f
    );
    border-radius: 2px;
    border: none;
  }
  .is-hanger{
    width: 630px;
    background: #f1f3f9;
    color: #333;
    font-size: 16px;
  }
  /deep/ .formRelative {
    .el-form-item__content {
      position: static !important;
    }
  }
}
.price-box {
  flex:1;
  padding:12px 20px;
  .price-text {
    padding-bottom: 2.8px;
    margin: 0px;
  }
}
.process-list {
  display: flex;
  justify-content: space-between;
  &>div {
    font-family: PingFangSC-Regular;
    font-size: 10px;
    color: #A8AAAE;
    letter-spacing: 0;
    line-height: 10px;
  }
}
.process-show {
  margin: 18.6px 34px 0;
  &>div {
    font-family: PingFangSC-Medium;
    font-size: 12px;
    color: #FFFFFF;
    line-height: 28px;
    background: #22c686;
    border-radius: 14px;
    padding: 0 16px;
  }
  .not-start-process {
    color: #A7A7A7;
    border: 1px solid #A7A7A7;
    border-radius: 14px;
    background: white;
  }
}
.delete-around {
  justify-content: start;
}
.content-text {
  padding-left: 60px;
  flex: auto;
}
.mini-carousel-list {
  margin-top: 10px;
  display: flex;
  height: 80px;
  .arrow-btn {
    cursor: pointer;
    background: #E9EAEB;
    border: 1px solid #C2C2C2;
    color: #C2C2C2;
    text-align: center;
    line-height: 78px;
    width: 14px;
    flex: none;
  }
  .mini-carousel-box {
    flex: auto;
    overflow: hidden;
    height: 80px;
  }
  .mini-carousel-content {
    display: flex;
    height: 100%;
    flex-wrap: nowrap;
    img {
      flex: none;
      box-sizing: border-box;
      margin-left: 6px;
      cursor: pointer;
      width: 80px;
      height: 80px;
    }
    .mini-active {
      border: 2px solid #FF7067;
    }
  }
}
.el-divider--horizontal {
  margin:18px 0;
}
.village-tabs {
  /deep/ .el-tabs__item{
    &>span{
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #60697E;
      letter-spacing: 0;
    }
  }
  .el-icon-my {
    margin-right: 6.9px;
  }
  .el-icon-my:before{
    content: "\e611";
    font-size: 16px;
    visibility: hidden;
  }
  .el-icon-my-about{
    background: url("~@/assets/icon/tabs_a.png") center no-repeat;
    background-size: cover;
  }
  .el-icon-my-notice {
    background: url("~@/assets/icon/tabs_b.png") center no-repeat;
    background-size: cover;
  }
  .el-icon-my-record {
    background: url("~@/assets/icon/tabs_c.png") center no-repeat;
    background-size: cover;
  }
  .el-icon-my-result {
    background: url("~@/assets/icon/tabs_d.png") center no-repeat;
    background-size: cover;
  }
  /deep/ .el-tabs__item.is-active {
    &>span {
      position: relative;
      color: #22C686;
      .triangle-img {
        position: absolute;
        bottom: -10px;
        left: 50%;
        width: 0;
        height: 0;
        border-bottom: 6px solid #22C686;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
      }
    }
    .el-icon-my-about{
      background: url("~@/assets/icon/tabs_a_active.png") center no-repeat;
      background-size: cover;
    }
    .el-icon-my-notice {
      background: url("~@/assets/icon/tabs_b_active.png") center no-repeat;
      background-size: cover;
    }
    .el-icon-my-record {
      background: url("~@/assets/icon/tabs_c_active.png") center no-repeat;
      background-size: cover;
    }
    .el-icon-my-result {
      background: url("~@/assets/icon/tabs_d_active.png") center no-repeat;
      background-size: cover;
    }
  }
}
</style>
